import { PageHeader } from "@/components/site/shared";
import CustomerReviews from "@/components/site/CustomerReviews";

export default function Reviews() {
  return (
    <div>
      <PageHeader overline="Customer Reviews" title="Real Experiences From Our Customers"
        subtitle="Honest, verified feedback from Veterans Power Wash & Cleaning Services customers." />
      <CustomerReviews mode="full" />
    </div>
  );
}
